export const TEXT_AREA_DISABLED = 'data-disabled';
export const TEXT_AREA_THEME = 'data-theme';
export const TEXT_AREA_ERROR = 'data-error';
export const TEXT_AREA_SUCCESS = 'data-success';
export const TEXT_AREA_FOCUS = 'data-focused';
//# sourceMappingURL=dataKeys.js.map